import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {SelectMenuModel} from '@shared/components/select-menu/model/select-menu.model';

@Component({
    selector: 'app-select-menu',
    templateUrl: './select-menu.component.html',
    styleUrls: ['./select-menu.component.scss']
})
export class SelectMenuComponent implements OnInit {
    @ViewChild('selectItem', {static: false}) selectItem: ElementRef | undefined;
    @Input() placeholder: string;
    @Input() tabIndex: number;
    @Input() showDeselectedOptions: boolean;
    @Input() options: SelectMenuModel[];
    @Input() dropdownWidth: string;
    @Input() dropdownHeight: number;
    @Input() labelWidth: string;
    @Input() labelCssClasses: any;
    @Input() cssClasses: string;
    @Input() labelClasses: string;
    @Input() selectLabel: string;
    @Input() labelText: string;
    @Input() fontSizeClasses: string;
    @Input() disabled: boolean;
    @Input() ariaLabel: string;
    @Input() selectedId: any;
    @Input() requiredField: boolean;
    @Input() formFieldControl: FormControl;
    @Input() formFieldGroup: FormGroup;
    @Output() valueChangeEvent = new EventEmitter();
    keyboardFocus: boolean;

    ngOnInit(): void {
        this.tabIndex = this.disabled === true ? -1 : 0;
    }

    valueChanged(value: any): void {
        this.valueChangeEvent.emit(value);
    }

    onKeyUp(event): void {
        const selectedElement = this.selectItem?.nativeElement.querySelector('mat-form-field').classList.contains('mat-focused');
        if (event.key === 'Tab') {
            this.keyboardFocus = !!selectedElement;
        }
    }
}
